import { render, staticRenderFns } from "./sw-banner-card.vue?vue&type=template&id=c4a91e8c&"
import script from "./sw-banner-card.vue?vue&type=script&lang=tsx&"
export * from "./sw-banner-card.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports